'use client';

import React from 'react';
import { Section } from '@/components/client/Section/Section';
import { Container } from '@/components/client/Container/Container';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { Faq } from '@/features/client/FAQ/Faq';

const FaqPage = () => {
  return (
    <div>
      {' '}
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection label="FAQ" title="FAQ" description="" />
      </MainSectionLayout>
      <Section variant="secondary">
        <Container>
          <Faq />
        </Container>
      </Section>
      <Section>
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default FaqPage;
